// src/services/StorageService.js
import Cookies from "js-cookie";

const TOKEN_COOKIE = "auth_token";
const USER_KEY_PERSIST = "auth_user";
const USER_KEY_SESSION = "auth_user_session";

// central place to tweak cookie policy
const defaultCookieOpts = (days) => ({
  // if days provided, persistent cookie; else session cookie
  ...(days ? { expires: days } : {}),
  secure: window.location.protocol === "https:", // only set secure on https
  sameSite: "Lax", // Changed from "Strict" to "Lax" to allow cookie to be sent on navigation
  path: "/",
});

const StorageService = {
  /**
   * Persist auth based on remember flag.
   * - token in cookie
   * - user in localStorage (remember) or sessionStorage (no remember)
   */
  setAuth({ token, user }, { remember = false, cookieDays = 7 } = {}) {
    if (!token) return;

    // token → cookie (httpOnly would be best, but must be set by server)
    Cookies.set(TOKEN_COOKIE, token, defaultCookieOpts(remember ? cookieDays : undefined));

    // user → storage
    const userStr = JSON.stringify(user || {});
    if (remember) {
      localStorage.setItem(USER_KEY_PERSIST, userStr);
      sessionStorage.removeItem(USER_KEY_SESSION);
    } else {
      sessionStorage.setItem(USER_KEY_SESSION, userStr);
      localStorage.removeItem(USER_KEY_PERSIST);
    }
  },

  getToken() {
    return Cookies.get(TOKEN_COOKIE) || null;
  },

  getUser() {
    // prefer persistent; else session
    const fromLocal = localStorage.getItem(USER_KEY_PERSIST);
    if (fromLocal) return JSON.parse(fromLocal);
    const fromSession = sessionStorage.getItem(USER_KEY_SESSION);
    return fromSession ? JSON.parse(fromSession) : null;
  },

  isAuthenticated() {
    return !!this.getToken();
  },

  clearAuth() {
    Cookies.remove(TOKEN_COOKIE, { path: "/" });
    localStorage.removeItem(USER_KEY_PERSIST);
    sessionStorage.removeItem(USER_KEY_SESSION);
  },
};

export default StorageService;
